'use strict';

var adapters = require('@leancloud/platform-adapters-node');

module.exports = function (AV) {
  AV.setAdapters(adapters);
  return AV;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/leancloud-storage/dist/node/entry/use-adapters.js
// module id = SzZE
// module chunks = 0